import { Form, Row, Col, Radio, Select } from "antd";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Option } from "./AddEditItem";
import InputName from "../UI/InputNumberComponent/InputName";
import { InputNumbers } from "../UI/InputNumberComponent/NumericInput";
import { useQuery } from "react-query";
import { getItemUnitDropdown } from "../../api/itemUnit";
import { Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

type prop = {
  formatedcategory: Option[] | undefined;
  loadingcategory: boolean;
  formatedBrand: Option[] | undefined;
  loadingBrand: boolean;
  formatedSupplier: Option[] | undefined;
  loadingSupplier: boolean;
  formatedPriceScheme: Option[] | undefined;
  loadingPriceScheme: boolean;
  setCategory: any;
  setItemName: any;
  setBarcode: any;
  setType: any;
  setItemUnit: any;
  setSelectedCategory: Dispatch<any>;
  setSelectedItemUnit: Dispatch<any>;
  setIsSaveHide: Dispatch<SetStateAction<boolean>>;
  isEdit: () => boolean;
  item: any;
};

export const GeneralInformation = ({
  loadingcategory,
  formatedcategory,
  formatedBrand,
  loadingBrand,
  loadingSupplier,
  formatedSupplier,
  formatedPriceScheme,
  loadingPriceScheme,
  setItemName,
  setBarcode,
  setSelectedCategory,
  setSelectedItemUnit,
  setIsSaveHide,
  isEdit,
  item,
}: prop) => {
  const [t] = useTranslation("common");
  const [, setValue] = useState(1);
  const baseURL = (window as any).REACT_APP_BASE_API_URL

  const [selectedValue, setSelectedValue] = useState(item?.type?.id || 1);
  const [allData, setAllData] = useState([]);

  const handleOnChange = (newValue: any) => {
    if (newValue < 1) {
      setValue(1);
    } else {
      setValue(newValue);
    }
  };

  const handleNameChange = (event: any) => {
    setItemName(event);
  };
  const handleBarcodeChange = (event: any) => {
    setBarcode(event);
  };

  const [formatedItemUnit, setFormatedItemUnit] = useState<
    { value: number; label: string }[] | undefined
  >();

  const { isLoading: loadingItemUnit } = useQuery(
    "ItemUnit",
    getItemUnitDropdown,
    {
      onSuccess: (res) => {
        const response = res.data;
        setAllData(response);
      },
    }
  );
  const handleRadioChange = (e: any) => {
    setSelectedValue(e.target.value);
  };

  useEffect(() => {
    if (allData.length) {
      const filterAllData = allData
        .filter((item: any) =>
          isEdit()
            ? item && item.itemTypeId === selectedValue
            : item.isActive && item.itemTypeId === selectedValue
        )
        .map((unit: any) => {
          return { value: unit.id, label: unit.name };
        });
      setFormatedItemUnit(filterAllData);
    }
  }, [selectedValue, allData]);

  return (
    <>
      <Row>
        <Col span={6}>
          <Form.Item
            name="image"
            label={`${t("image")}`}
          >
            <Upload
              name="image"
              listType="picture-card"
              maxCount={1}
              beforeUpload={() => false}
              defaultFileList={[
                {
                  uid: '-1',
                  name: '',
                  status: 'done',
                  url: item?.image ? `${baseURL}/images/${item.image}` : `${baseURL}/images/default.png`
                },
              ]}
              onChange={() => {
                setIsSaveHide(true);
              }}
            >
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>{t("Upload")}</div>
              </div>
            </Upload>

          </Form.Item>
          <Form.Item
            name="categoryId"
            label={`${t("category")}`}
            rules={[
              {
                required: true,
                message: "category is required",
              },
            ]}
          >
            <Select
              data-testid="category"
              placeholder={`${t("select-category")}`}
              loading={loadingcategory}
              options={formatedcategory}
              showSearch={true}
              optionFilterProp="label"
              onChange={(value: any) => {
                setSelectedCategory(value);
                setIsSaveHide(true);
              }}
            />
          </Form.Item>

          <Form.Item
            name="name"
            label={`${t("item-name")}`}
            rules={[
              {
                required: true,
                message: "item name is required",
              },
            ]}
          >
            <InputName
              maxLength={50}
              onChange={(event: any) => {
                handleNameChange(event);
                setIsSaveHide(true);
              }}
              data-testid="itemName"
            />
          </Form.Item>

          <Form.Item name="brandId" label={`${t("brand")}`}>
            <Select
              data-testid="brand"
              placeholder={`${t("select-brand")}`}
              loading={loadingBrand}
              options={formatedBrand}
              showSearch={true}
              optionFilterProp="label"
              onChange={() => setIsSaveHide(true)}
            />
          </Form.Item>

          <Form.Item name="supplierId" label={`${t("main-supplier")}`}>
            <Select
              data-testid="mainsupp"
              placeholder={t("select-supplier")}
              loading={loadingSupplier}
              options={formatedSupplier}
              showSearch={true}
              optionFilterProp="label"
              onChange={() => setIsSaveHide(true)}
            />
          </Form.Item>
        </Col>

        <Col span={6} offset={2}>
          <Form.Item name="barcode" label={`${t("barcode")}`} rules={[
            {
              required: isEdit(),
              message: "Barcode is required",
            },
          ]}>
            <InputName
              maxLength={20}
              onChange={(value: any) => {
                setIsSaveHide(true);
                handleBarcodeChange(value);
              }}
            />
          </Form.Item>

          <Form.Item name="priceSchemeId" label={`${t("price-sheme")}`}>
            <Select
              data-testid="priceScheme"
              placeholder={t("select-price-scheme")}
              loading={loadingPriceScheme}
              options={formatedPriceScheme}
              showSearch={true}
              onChange={() => setIsSaveHide(true)}
              optionFilterProp="label"
            />
          </Form.Item>

          <Form.Item name="sku" label={`${t("sku")}`}>
            <InputName maxLength={20} data-testid="SKU" />
          </Form.Item>

          <Col span={24}>
            <Form.Item
              name="minInStock"
              label={`${t("minimum-quantity-in-stock")}`}
              initialValue={1}
            >
              <InputNumbers
                maxLength={11}
                onChange={(newValue: any) => {
                  setIsSaveHide(true);
                  handleOnChange(newValue);
                }}
              />
            </Form.Item>
          </Col>
        </Col>

        <Col span={6} offset={2}>
          <Form.Item
            name="typeId"
            label={t("type")}
            initialValue={1}
            rules={[
              {
                required: true,
                message: "type is required",
              },
            ]}
          >
            <Radio.Group name="typeId" onChange={handleRadioChange}>
              <Radio value={1}>{t("piece")}</Radio>
              <Radio value={2}>{t("weigth")}</Radio>
              <Radio value={3}>{t("size")}</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="unitId"
            label={`${t("item-unit")}`}
            rules={[
              {
                required: true,
                message: "item unit is required",
              },
            ]}
          >
            <Select
              data-testid="unitItem"
              placeholder={`${t("select-item-unit")}`}
              loading={loadingItemUnit}
              options={formatedItemUnit}
              showSearch={true}
              optionFilterProp="label"
              onChange={(value: any) => {
                // console.log(value);
                setSelectedItemUnit(value);
                setIsSaveHide(true);
              }}
            />
          </Form.Item>

          <Form.Item name="listOrder" label={`${t("item-order")}`}>
            <InputName
              maxLength={5}
              data-testid="itemOrder"
              onChange={() => setIsSaveHide(true)}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
